import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { RailStoreV2 } from '@kaltura-ott/tvpil-shared';

import { checkIsLogoRail } from './checkIsLogoRail';

export function checkIsSeriesCatchUpRail(rail: RailStoreV2) {
  return (
    rail?.subtype === UIDAPresentationTypeEnum.series_catch_up && !checkIsLogoRail(rail)
  );
}
